<template>
  <div class="yxtbiz-exam-arrange mb8">
    <div>
      <yxt-steps :active="step" basic>
        <yxt-step :title="$t('pc_biz_ote_lbl_baseinfo')"></yxt-step>
        <yxt-step :title="$t('pc_biz_ote_lbl_examsetting')"></yxt-step>
        <yxt-step :title="$t('pc_biz_ote_lbl_marksetting')" v-if="needCheck"></yxt-step>
      </yxt-steps>
    </div>
    <div class="pt40">
      <base-info :functionCode="functionCode" :dataPermissionCodes="dataPermissionCodes" ref="base" :reward="reward" v-show="step === 0" @next="next" :id.sync="id" :arrange="arrange" :masterId="masterId" :masterName="masterName||''" :masterType="masterType" @needCheckChange="needCheckChange"/>
      <setting :functionCode="functionCode" :dataPermissionCodes="dataPermissionCodes" ref="setting" v-show="step === 1" @next="next" :id="id" :arrange="arrange"/>
      <mark-setting :functionCode="functionCode" :dataPermissionCodes="dataPermissionCodes" ref="mark" v-show="step === 2" @next="next" :id="id" :arrange="arrange"/>
    </div>
    <div class="fixedFooterStyle width960">
      <div class="text-right pr32">
        <yxt-button plain @click="submitForm(-1)" v-if="step > 0">{{ $t('pc_biz_ote_btn_prev') }}</yxt-button>
        <yxt-button :type="maxStep > step ? '' : 'primary'" @click="submitForm(0)" v-if="maxStep === step">{{ $t('pc_biz_ote_btn_confirm') }}</yxt-button>
        <yxt-button :type="'primary'" @click="submitForm(1)" v-if="maxStep > step">{{ $t('pc_biz_ote_btn_next') }}</yxt-button>
      </div>
    </div>
  </div>
</template>

<script>
import baseInfo from './arrange/baseInfo';
import setting from './arrange/setting';
import markSetting from './arrange/markSetting';
import { getArrange, externalArrangeCreate, externalArrangeUpdate } from './service';
import {
  Steps,
  Step
} from 'yxt-pc';
export default {
  name: 'YxtbizExamArrange',
  name_zh: '安排考试组件',
  components: {
    baseInfo,
    setting,
    markSetting,
    YxtSteps: Steps,
    YxtStep: Step
  },
  eventList: [{
    type: 'save',
    handler: 'saveEnd',
    label: '创建考试组件后的回调事件'
  }],
  props: {
    arrangeId: {
      type: String,
      required: false,
      default: '',
      desc: '考试安排ID',
      setter: 'StringSetter'
    },
    masterId: {
      type: String,
      required: true,
      desc: '考试安排关联对象ID',
      setter: 'StringSetter'
    },
    masterName: {
      type: String,
      required: false,
      desc: '考试安排关联对象名称（暂时无用，可以不填）',
      setter: 'StringSetter'
    },
    // 第三方考试安排类型
    masterType: {
      type: Number,
      required: true,
      desc: '考试安排关联对象类型',
      setter: 'SelectSetter',
      enums: [{
        label: '普通考试',
        value: 0
      }, {
        label: '项目考试',
        value: 1
      }, {
        label: '课程包考试',
        value: 2
      }, {
        label: '练习考试',
        value: 3
      }]
    },
    // 是否奖励
    reward: {
      type: Boolean,
      required: false,
      default: true,
      desc: '是否可奖励学分积分',
      setter: 'BooleanSetter'
    },
    functionCode: {
      type: String,
      default: '',
      desc: '导航权限',
      setter: 'StringSetter'
    },
    dataPermissionCodes: {
      type: Object,
      default: () => {
        return {
          arrange: '', // 安排考试
          selectExam: '', // 控制选择试卷
          selectCer: '', // 控制选择证书
          selectMarker: '' // 选择批阅人
        };
      },
      desc: '数据权限（arrange 安排考试, selectExam 控制选择试卷, selectCer 控制选择证书, selectMarker 选择批阅人）',
      setter: 'JsonSetter'
    }
  },
  data() {
    return {
      needCheck: 0,
      saveLock: 0,
      step: 0,
      maxStep: 2,
      id: '',
      arrange: {},
      edited: [true, false, false],
      formDataAll: {}
    };
  },
  watch: {
    step(val) {
      this.edited[val] = true;
    },
    arrangeId(val) {
      this.id = val;
    },
    examCatalogSearch(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    this.id = this.arrangeId;
    if (this.id) {
      this.getArrangeInfo();
    }
  },
  methods: {
    needCheckChange(needCheck) {
      this.needCheck = needCheck;
      this.maxStep = this.needCheck ? 2 : 1;
    },
    // 获取考试安排信息
    getArrangeInfo(isSaveEnd) {
      getArrange(this.id).then(res => {
        this.arrange = res;
        this.arrange.usedTimesLenMin = this.arrange.usedTimesLen / 60;
        if (isSaveEnd) {
          // 保存完成
          this.$emit('save', this.arrange);
        }
      }).catch(err => {
        if (err.error) {
          err = err.error;
        }
        this.$message({
          type: 'warning',
          message: err.message
        });
      });
    },
    submitForm(go) {
      if (go === 1) {
        this.begainNext();
      } else if (go === -1) {
        this.step--;
      } else {
        // this.saveData();
        this.saveDataAll();
      }
    },
    begainNext() {
      switch (this.step) {
        case 0:
          let setArr = this.$refs.base.submitForm(true, false);
          if (setArr) {
            if (!this.arrangeId) {
              setArr.status = 0;
            }
            Object.assign(this.arrange, setArr);
          }
          break;
        case 1:
          this.$refs.setting.submitForm(1, false);
          break;
        case 2:
          this.saveData();
          break;
        default:
          break;
      }
    },
    next(lastStep, isSave) {
      // if (newId) {
      //   this.id = newId;
      // }
      this.$nextTick(() => {
        if (isSave) {
          lastStep = lastStep + 1;
          this.saveData(lastStep);
        } else {
          this.step++;
        }
      });
    },
    // 全部一起保存
    saveDataAll() {
      this.formDataAll = {
        'arrangeBaseInfo': null,
        'arrangeControlInfo': null,
        'examArrangeMarker': null
      };
      // 基本信息表单
      this.formDataAll.arrangeBaseInfo = this.$refs.base.submitForm(true, true);
      if (!this.formDataAll.arrangeBaseInfo) {
        this.step = 0;
        return;
      }
      // 设置信息表单
      this.formDataAll.arrangeControlInfo = this.$refs.setting.submitForm(true, true);
      if (!this.formDataAll.arrangeControlInfo) {
        this.step = 1;
        return;
      }
      this.formDataAll.arrangeControlInfo.usedTimesLen = this.formDataAll.arrangeControlInfo.usedTimesLenMin * 60;
      // 批阅人表单
      this.formDataAll.examArrangeMarker = this.$refs.mark.submitForm(true, true);
      if (!this.formDataAll.examArrangeMarker) {
        this.step = 2;
        return;
      }
      if (this.id) {
        externalArrangeUpdate(this.id, this.formDataAll, this.functionCode, this.dataPermissionCodes.arrange).then(res => {
          this.saveEnd(res);
        }).catch(err => {
          if (err.error) {
            err = err.error;
          }
          this.$message({
            type: 'warning',
            message: err.message
          });
        });
      } else {
        externalArrangeCreate(this.formDataAll, this.functionCode, this.dataPermissionCodes.arrange).then(res => {
          this.saveEnd(res);
        }).catch(err => {
          if (err.error) {
            err = err.error;
          }
          this.$message({
            type: 'warning',
            message: err.message
          });
        });
      }
    },
    saveEnd(res) {
      Object.assign(this.arrange, this.formDataAll.arrangeBaseInfo);
      Object.assign(this.arrange, this.formDataAll.arrangeControlInfo);
      Object.assign(this.arrange, this.formDataAll.examArrangeMarker);
      Object.assign(this.arrange, res);
      this.$emit('save', this.arrange);
    },
    // 一步一步保存 暂时弃用
    saveData(saveStep) {
      if (this.saveLock++ > 100) {
        return;
      }
      if (!saveStep) {
        saveStep = 0;
      }
      if (saveStep > 2) {
        this.getArrangeInfo(true);
      }
      if (this.edited[saveStep]) {
        // 保存编辑过的
        switch (saveStep) {
          case 0:
            this.$refs.base.submitForm(true, true);
            break;
          case 1:
            this.$refs.setting.submitForm(1, true);
            break;
          case 2:
            this.$refs.mark.submitForm(true);
            break;
          default:
            break;
        }
      }
    },
    checkChange() {
      return this.$refs.base.checkChange() || this.$refs.setting.checkChange() || this.$refs.mark.checkChange();
    }
  }
};
</script>
